import React from 'react';

import { Collapse } from '@mui/material';
import { useToggle } from 'react-use';
import { Surface, TitleWithDescription, YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './NbzCustomerSetupFinalizationChecklist.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CheckPointsList } from './CheckPointsList/CheckPointsList';
import { useSetupFinalizationChecklist } from './hooks/useSetupFinalizationChecklist';

type NgzCustomerSetupFinalizationChecklistProps = {
  customerId: number;
};

// only for new flow and coach, control on the page
const NgzCustomerSetupFinalizationChecklist = ({
  customerId,
}: NgzCustomerSetupFinalizationChecklistProps) => {
  const [isShowPoints, toggleIsShowPoints] = useToggle(true);
  const { isShowWidget, handleFinishChecklist } =
    useSetupFinalizationChecklist(customerId);

  if (!isShowWidget) {
    return null;
  }

  return (
    <Surface className={classes.box}>
      <TitleWithDescription
        title="Congrats! The consultation is complete and your client is ready to begin using SWYMO app!"
        description="Do these things immediately"
        titleFont="body-14-bold"
      />
      <Collapse in={isShowPoints}>
        <CheckPointsList />
      </Collapse>
      <YesNoBtnRow
        yesText="Finish"
        yesHandler={handleFinishChecklist}
        noText={isShowPoints ? 'Hide' : 'Expand'}
        noHandler={toggleIsShowPoints}
        size="small"
      />
    </Surface>
  );
};

angularizeWithProviders(
  NgzCustomerSetupFinalizationChecklist,
  'ngzCustomerSetupFinalizationChecklist',
  { customerId: '<' },
);

export { NgzCustomerSetupFinalizationChecklist };
